/**
 * Shared App Proxy events-v fetch + in-flight/response cache.
 * Same product near US-center inventory queries coalesce to one network GET.
 */
(function (w) {
  if (w.AMCWorkshopEventsV) return;

  var US_LAT = 39.833333;
  var US_LNG = -98.583333;
  var US_RADIUS = 5000;
  var inFlight = Object.create(null);
  var resolved = Object.create(null);

  function roundCoord(n) {
    return Math.round(Number(n) * 1e4) / 1e4;
  }

  function isUsCenterInventory(lat, lng, radiusKm) {
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
    if (Math.abs(lat - US_LAT) > 0.15 || Math.abs(lng - US_LNG) > 0.15) return false;
    if (!Number.isFinite(radiusKm) || radiusKm < 2000) return false;
    return true;
  }

  function cacheKey(opts) {
    var gid = String(opts.productGid || '').trim();
    var lat = Number(opts.lat);
    var lng = Number(opts.lng);
    var radiusKm = Number(opts.radiusKm);
    var empty = opts.includeEmpty === true;
    /* US-center inventory: one GET per product (date filters applied by callers). */
    if (isUsCenterInventory(lat, lng, radiusKm)) {
      return 'inv|' + gid + '|0';
    }
    return [
      'raw',
      gid,
      roundCoord(lat),
      roundCoord(lng),
      Number.isFinite(radiusKm) ? radiusKm : '',
      empty ? '1' : '0',
      opts.startDate || '',
      opts.endDate || ''
    ].join('|');
  }

  function buildUrl(opts) {
    var proxy = String(opts.proxyBase || '/apps/workshop-events').replace(/\/+$/, '');
    var path = String(opts.eventsPath || '/events-v').trim();
    if (path.charAt(0) !== '/') path = '/' + path;
    var lat = Number(opts.lat);
    var lng = Number(opts.lng);
    var radiusKm = Number(opts.radiusKm);
    var empty = opts.includeEmpty === true;
    var startDate = opts.startDate || '';
    var endDate = opts.endDate || '';
    if (isUsCenterInventory(lat, lng, radiusKm)) {
      lat = US_LAT;
      lng = US_LNG;
      radiusKm = US_RADIUS;
      empty = false;
      startDate = '';
      endDate = '';
    }
    var url =
      proxy +
      path +
      '?product_gid=' +
      encodeURIComponent(String(opts.productGid || '').trim()) +
      '&lat=' +
      encodeURIComponent(lat) +
      '&lng=' +
      encodeURIComponent(lng) +
      '&radius_km=' +
      encodeURIComponent(radiusKm) +
      '&include_empty_venues=' +
      (empty ? 'true' : 'false');
    if (startDate) url += '&start_date=' + encodeURIComponent(startDate);
    if (endDate) url += '&end_date=' + encodeURIComponent(endDate);
    return url;
  }

  function get(opts) {
    opts = opts || {};
    var gid = String(opts.productGid || '').trim();
    if (!gid) return Promise.reject(new Error('productGid required'));

    var key = cacheKey(opts);
    if (resolved[key]) {
      return Promise.resolve(resolved[key]);
    }
    if (inFlight[key]) return inFlight[key];

    var url = buildUrl(opts);
    var p = fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('events-v ' + res.status);
        return res.json();
      })
      .then(function (data) {
        resolved[key] = data;
        delete inFlight[key];
        return data;
      })
      .catch(function (err) {
        delete inFlight[key];
        throw err;
      });

    inFlight[key] = p;
    return p;
  }

  w.AMCWorkshopEventsV = {
    get: get,
    US_LAT: US_LAT,
    US_LNG: US_LNG,
    US_RADIUS: US_RADIUS
  };
})(window);
